import React from 'react'
import PropTypes from 'prop-types'

import styles from './../style/KatalogDlaBani.module.scss'

import { Container, Image } from 'react-bootstrap'

import WhiteBlockTitle from './WhiteBlockTitle'
import GreenButton from './GreenButton'
import StormcloudButton from './StormcloudButton'
import FeedbackForm from './FeedbackForm'
import ClientOnlyFsLightbox from './ClientOnlyFsLightbox'

class KatalogDlaBani extends React.Component {
  
  constructor(props) {
    super(props)

    this.state = {
      show_feedback: false,
      show_feedback2: false,
      lightboxController: {
        toggler: false,
        slide: 1
      }
    }
  }

  showFeedback = () => {
    this.setState({ show_feedback: true });
  }
  closeFeedback = () => {
    this.setState({ show_feedback: false });
  }

  showFeedback2 = () => {
    this.setState({ show_feedback2: true });
  }
  closeFeedback2 = () => {
    this.setState({ show_feedback2: false });
  }

  openLightbox = (index) => {
    this.setState({
      lightboxController: {
        toggler: !this.state.lightboxController.toggler,
        slide: index + 1
      }
    })
  }

  formatSlideNumber = (index) => {
    // Добавляем ведущий ноль для чисел меньше 10
    return `[${index < 9 ? '0' + (index + 1) : index + 1}]`
  }

  render() {

    const { list, assets_path, show_icons, title, rtext, text, className, imageVar, btn } = this.props,
    { show_feedback, show_feedback2, lightboxController } = this.state

    return (
      <section className={`${styles.section} ${styles[className]}`}>
        <Container>
          <WhiteBlockTitle
            title={title}
            text={rtext}
          />
          
          {/* Lightbox компонент */}
          <ClientOnlyFsLightbox
            toggler={lightboxController.toggler}
            sources={list.map(item => item.full || item.image)}
            slide={lightboxController.slide}
          />

          {text != `` &&
            <div className={styles.text} dangerouslySetInnerHTML={{__html: text}} />
          }
          <div className={styles.list}>
            {list.map( ( elm, k ) => (
              <div key={k} className={styles.elm}>
                <div className='d-flex align-items-end d-none d-xl-block'>
                  {imageVar == 1 &&
                    <div onClick={() => this.openLightbox(k)} style={{cursor: 'pointer'}}>
                      <Image className={styles.elm_image} src={elm.image} width={358} height={325} alt={elm.name} />
                    </div>
                  }
                  {imageVar == 2 &&
                    <div onClick={() => this.openLightbox(k)} style={{cursor: 'pointer'}}>
                      <Image className={styles.elm_image2} src={elm.image} width={368} height={152} alt={elm.name} />
                    </div>
                  }
                </div>
                <div className={styles.elm_col_1}>
                  <div className={styles.elm_name} dangerouslySetInnerHTML={{__html: elm.name}} />
                  <div className={styles.elm_text} dangerouslySetInnerHTML={{__html: elm.text}} />
                </div>
                <div className={styles.elm_col_2}>
                  <div className={styles.elm_col_2_top}>
                    <div>Подберите окно для себя</div>
                    <div>{this.formatSlideNumber(k)}</div>
                  </div>
                  {show_icons &&
                    <div className={styles.elm_col_2_icons}>
                      <div className={styles.elm_col_2_icons_el}>
                        <div className={styles.elm_col_2_icons_el_icon}>
                          <Image src={`/${assets_path}/images/crown.svg`} width={21} height={21} alt={`Премиальный внешний вид`} />
                        </div>
                        <div className={styles.elm_col_2_icons_el_name}>
                          Премиальный<br />
                          внешний вид
                        </div>
                      </div>
                      <div className={styles.elm_col_2_icons_sep} />
                      <div className={styles.elm_col_2_icons_el}>
                        <div className={styles.elm_col_2_icons_el_icon}>
                          <Image src={`/${assets_path}/images/like.svg`} width={21} height={21} alt={`Высокое качество`} />
                        </div>
                        <div className={styles.elm_col_2_icons_el_name}>
                          Высокое<br />
                          качество
                        </div>
                      </div>
                      <div className={styles.elm_col_2_icons_sep} />
                      <div className={styles.elm_col_2_icons_el}>
                        <div className={styles.elm_col_2_icons_el_icon}>
                          <Image src={`/${assets_path}/images/grid-7.svg`} width={21} height={21} alt={`Немецкая фурнитура`} />
                        </div>
                        <div className={styles.elm_col_2_icons_el_name}>
                          Немецкая<br />
                          фурнитура
                        </div>
                      </div>
                    </div>
                  }
                  <div className={styles.elm_col_2_sep} />
                  <div className={styles.elm_col_psize}>
                    <div className={styles.elm_col_psize_el}>
                      <Image src={`/${assets_path}/images/empty-wallet.svg`} width={20} height={21} alt={`Цена`} />
                      <div>
                        <div className={styles.elm_col_psize_el_title}>Цена</div>
                        <div className={styles.elm_col_psize_el_val}>{elm.price}</div>
                      </div>
                    </div>
                    <div className={styles.elm_col_psize_el}>
                      <Image src={`/${assets_path}/images/maximize.svg`} width={24} height={24} alt={`Размеры`} />
                      <div>
                        <div className={styles.elm_col_psize_el_title}>Размеры</div>
                        <div className={styles.elm_col_psize_el_val}>{elm.size}</div>
                      </div>
                    </div>
                  </div>
                  <div className={styles.elm_col_2_sep} />
                  <div className={styles.elm_col_2_btns}>
                    <GreenButton
                      text={`Заказать окно`}
                      width={174}
                      action={() => this.showFeedback()}
                    />
                    <FeedbackForm
                      title={`Заказать окно`}
                      text={`Свяжитесь с нами и мы оперативно проконсультируем вас`}
                      btn={`Отправить`}
                      data={[]}
                      show={show_feedback}
                      handleClose={() => this.closeFeedback()}
                    />
                    <StormcloudButton
                      text={btn}
                      width={194}
                      action={() => this.showFeedback2()}
                    />
                    <FeedbackForm
                      title={btn}
                      text={`Свяжитесь с нами и мы оперативно проконсультируем вас`}
                      btn={`Отправить`}
                      data={[]}
                      show={show_feedback2}
                      handleClose={() => this.closeFeedback2()}
                    />
                  </div>
                </div>
                <div className='d-flex justify-content-center d-flex d-xl-none'>
                  <div onClick={() => this.openLightbox(k)} style={{cursor: 'pointer'}}>
                    <Image className={styles.elm_image} src={elm.image} width={358} height={325} alt={elm.name} />
                  </div>
                </div>
              </div>
            ) )}
          </div>
        </Container>
      </section>
    )
  }
}

KatalogDlaBani.propTypes = {
  list: PropTypes.array,
  assets_path: PropTypes.string,
  show_icons: PropTypes.bool,
  title: PropTypes.string,
  rtext: PropTypes.string,
  text: PropTypes.string,
  className: PropTypes.string,
  imageVar: PropTypes.number,
  btn: PropTypes.string
}

KatalogDlaBani.defaultProps = {
  list: [],
  assets_path: ``,
  show_icons: true,
  title: `Каталог`,
  rtext: ``,
  text: ``,
  className: `top`,
  imageVar: 1,
  btn: `Подобрать окно для бани`
}

export default KatalogDlaBani